import {Crops} from "../../../packages/graphql-layer/src/__generated__/crops"
import {CUSTOM_BREAKPOINTS} from "../../theming/themes/PortalTheme";


export interface ImageSource {
    minWidthBreakpoint?: number,
    cropName: string,
    width: number
}

export interface PictureSetting {
    defaultPicture: ImageSource,
    sources: Array<ImageSource>
}

export const C014StageCarouselPictureSettings: PictureSetting = {
    defaultPicture: { // mobile
        cropName: Crops.portrait_ratio1x1.cropName,
        width: Crops.portrait_ratio1x1.w890h890.width
    },
    sources: [
        {   // tablet
            minWidthBreakpoint: CUSTOM_BREAKPOINTS.values.sm,
            cropName: Crops.landscape_ratio16x9.cropName,
            width: Crops.landscape_ratio16x9.w1440h810.width
        },
        {   // desktop
            minWidthBreakpoint: CUSTOM_BREAKPOINTS.values.lg,
            cropName: Crops.landscape_ratio20x7.cropName,
            width: Crops.landscape_ratio20x7.w2780h973.width
        }
    ]
}

export const C015QuoteCarouselPictureSettings: PictureSetting = {
    defaultPicture: { // tablet
        cropName: Crops.portrait_ratio1x1.cropName,
        width: Crops.portrait_ratio1x1.w890h890.width
    },
    sources: [
        {   // desktop
            minWidthBreakpoint: CUSTOM_BREAKPOINTS.values.md,
            cropName: Crops.landscape_ratio20x7.cropName,
            width: Crops.landscape_ratio20x7.w2780h973.width
        }
    ]
}

export const F006AmountIncreaseForm: PictureSetting = {
    defaultPicture: { // tablet
        cropName: Crops.landscape_ratio16x9.cropName,
        width: Crops.landscape_ratio16x9.w960h540.width
    },
    sources: [
        {   // desktop
            minWidthBreakpoint: CUSTOM_BREAKPOINTS.values.md,
            cropName: Crops.landscape_ratio16x9.cropName,
            width: Crops.landscape_ratio16x9.w1440h810.width
        }
    ]
}

export const C060OverlayTeaserPictureSettings: PictureSetting = {
    defaultPicture: { // tablet
        cropName: Crops.landscape_ratio16x9.cropName,
        width: Crops.landscape_ratio16x9.w960h540.width
    },
    sources: [
        {   // desktop
            minWidthBreakpoint: CUSTOM_BREAKPOINTS.values.md,
            cropName: Crops.portrait_ratio3x4.cropName,
            width: Crops.portrait_ratio3x4.w780h1040.width
        }
    ]
}

export const C062OverlayFormPictureSettings: PictureSetting = {
    defaultPicture: { // tablet
        cropName: Crops.landscape_ratio16x9.cropName,
        width: Crops.landscape_ratio16x9.w960h540.width
    },
    sources: [
        {   // desktop
            minWidthBreakpoint: CUSTOM_BREAKPOINTS.values.md,
            cropName: Crops.portrait_ratio3x4.cropName,
            width: Crops.portrait_ratio3x4.w780h1040.width
        }
    ]
}

export const C094CallToActionCardPictureSettings: PictureSetting = {
    defaultPicture: {
        cropName: Crops.portrait_ratio1x1.cropName,
        width: Crops.portrait_ratio1x1.w890h890.width,
    },
    sources: [
        {
            minWidthBreakpoint: CUSTOM_BREAKPOINTS.values.xl,
            cropName: Crops.portrait_ratio1x1.cropName,
            width: Crops.portrait_ratio1x1.w1140h1140.width,
        },
    ],
}

export const C000DefaultTeaserPictureSettings: PictureSetting = {
    defaultPicture: { // mobile
        cropName: Crops.landscape_ratio16x9.cropName,
        width: Crops.landscape_ratio16x9.w960h540.width
    },
    sources: [
        {   // desktop
            minWidthBreakpoint: CUSTOM_BREAKPOINTS.values.md,
            cropName: Crops.landscape_ratio16x9.cropName,
            width: Crops.landscape_ratio16x9.w585h329.width
        }
    ]
}
